module.exports = __webpack_public_path__ + "img/l.97159128.jpg";